/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

// useDebouncedDispatch.ts
import {useCallback} from "react";
import {useDispatch} from "react-redux";
import debounce from "lodash/debounce";

export const useDebouncedDispatch = () => {
    const dispatch = useDispatch();

    // Debounce dispatch to delay execution until 500ms have passed since last invocation
    const debouncedDispatch = useCallback(
        debounce(action => dispatch(action), 200),
        [dispatch]
    );

    return {
        debouncedDispatch,
    };
};
